import React from 'react';
import BopppsPlanner from '../components/BopppsPlanner';

// `dark-surface` remaps the neutral Tailwind utilities used throughout this
// page — see src/styles/darkSurface.css.
const PlannerBasicPage = ({ lightMode = false }) => {
  return (
    <div className={`max-w-6xl mx-auto px-4 py-6${lightMode ? '' : ' dark-surface'}`}>
      <div className="bg-white shadow rounded-lg p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">BOPPPS Planner — included with LessonPlanner One</h1>
          <p className="text-gray-600 mt-2">
            Use the basic planner to outline your lesson using the BOPPPS model.
          </p>
        </div>
        <BopppsPlanner />
      </div>
    </div>
  );
};

export default PlannerBasicPage;
